export default __webpack_public_path__ + "static/media/cups-ca.f368b211.png";